import { useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { AxiosPublico } from "../../componentes/axios/Axios";
import {
  PedidosListarEstadoClienteId,
  PedidosListarEstadoEmpleadoId
} from "../../configuracion/apiUrls";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import Barras from "../graficos/Barras";
import Circular from "../graficos/Circular";

const Agenda = () => {
  const { usuario } = useContextUsuario();
  const [pedidos, setPedidos] = useState({ Pendiente: 0, Programada: 0, Completada: 0, Cancelada: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("Todos");
  const [verBarras, setVerBarras] = useState(true);

  const datosPedidos = {
    labels: Object.keys(pedidos),
    data: Object.values(pedidos),
    colors: ["#FFD700", "#32CD32", "#1E90FF", "#FF4500"],
    titulo: "Pedidos por estado",
  };

  const vBarras = () => setVerBarras(true);
  const vPastel = () => setVerBarras(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!usuario?.datoPersonales?.id || !usuario?.tipo) {
        return;
      }
      setLoading(true);
      setError(null);
      try {
        let pedidosUrl =
          usuario.tipo === "Cliente"
            ? `${PedidosListarEstadoClienteId}?clienteId=${usuario.datoPersonales.id}`
            : `${PedidosListarEstadoEmpleadoId}?empleadoId=${usuario.datoPersonales.id}`;

        const [pedidosResponse] = await Promise.all([
          AxiosPublico.get(pedidosUrl),
        ]);

        setPedidos(pedidosResponse.data || { Pendiente: 0, Programada: 0, Completada: 0, Cancelada: 0 });
      } catch (error) {
        setError("No se pudieron cargar las citas y pedidos.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [usuario?.datoPersonales?.id, usuario?.tipo]);

  return (
    <>
      {loading ? (
        <p className="text-center">Cargando citas y pedidos...</p>
      ) : error ? (
        <p className="text-center text-danger">{error}</p>
      ) : (
        <>
          {usuario.tipo === "Cliente" && (
                <>
                  <div className="row g-4 justify-content-center">
                    {/* Gráfica de Pedidos */}
                    {datosPedidos && (
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="grafica-container">
                          {verBarras ? (
                            <Circular datos={datosPedidos} />
                          ) : (
                            <Circular datos={datosPedidos} />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
            </>
          )}
          {usuario.tipo === "Empleado" && (
                <div className="row g-4">
                  <div className="col-12 col-md-6">
                    <div className="grafica-container">
                      {verBarras ? (
                        <Barras datos={datosPedidos} />
                      ) : (
                        <Circular datos={datosPedidos} />
                      )}
                    </div>
                  </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Agenda;